<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;

        <li class="breadcrumb-item active">Create</li>
      </ol>
    </nav>

    <h1 class="page-header-title">
      {{ 'raffleModule.createRaffle' | translate }}
    </h1>
  </header>
  <!-- End Page Header -->

  <section class="card">
    <div class="card-body">
      <div>
        <raffle-form (onSubmit)="onSubmit($event)"> </raffle-form>
      </div>
    </div>
  </section>
</div>
